import { requiredStpForTarget } from "../../engine/calculations";
import { currencyAxis, monthsAxis } from "./reckonerAxes";

const config = {
  key: "rr-stp-need",
  title: "STP Need-Based Ready Reckoner",
  category: "Ready Reckoners",
  description: "See the monthly STP transfer required to reach a range of goal amounts over a range of durations.",
  reckoner: true,
  rowAxis: currencyAxis("Goal Amount", [5_00_000, 10_00_000, 25_00_000, 50_00_000, 1_00_00_000]),
  colAxis: monthsAxis("Months", [12, 24, 36, 48, 60]),
  extraFields: [
    { key: "sourceRate", label: "Source fund return", type: "percent", default: 7, min: 0, max: 20, assumptionKey: "debtReturn" },
    { key: "targetRate", label: "Target fund return", type: "percent", default: 12, min: 0, max: 30, assumptionKey: "equityReturn" },
  ],
  computeCell(goal, months, extra) {
    const sourceRate = (Number(extra.sourceRate) || 0) / 100;
    const targetRate = (Number(extra.targetRate) || 0) / 100;
    return requiredStpForTarget(goal, sourceRate, targetRate, months);
  },
};

export default config;
